import React, { PureComponent } from "react";
import Modal from "react-modal";
import Cookies from "js-cookie";

function calculateFinalPrice(sum, options, discount) {
  const withoutDiscount = [...options].reduce((acc, opt) => acc + opt.sum, sum);
  if (!discount) return withoutDiscount;
  const { value, unit } = discount;
  const diff = unit === "%" ? (withoutDiscount * value) / 100 : value;
  return Math.ceil(withoutDiscount + diff);
}

function buildComment(comment, selectedModificator, selectedOptions) {
  let result = comment;
  if (selectedModificator && selectedModificator.kind) {
    const { kind, value, description } = selectedModificator;
    switch (kind) {
      case "number_of_players":
        result +=
          description && description !== ""
            ? ` / ${description}`
            : ` / игроков: ${value}`;
        break;
      case "duration":
        result +=
          description && description !== ""
            ? ` / ${description}`
            : ` / ${value} мин`;
        break;
      case "arbitrary":
        result += ` / ${description}`;
        break;
    }
  }
  const opts = [...selectedOptions].map(opt => opt.description).join(", ");
  if (opts && opts !== "") result += ` / ${opts}`;
  return result;
}

function modificatorDiff(selectedModificator, selectedOptions, discount) {
  if (!selectedModificator) return {};
  const { kind, value, sum } = selectedModificator;
  const result = {
    selectedModificator: selectedModificator,
    price: sum,
    priceWithOptions: calculateFinalPrice(sum, selectedOptions, discount)
  };
  switch (kind) {
    case "number_of_players":
      return { ...result, number_of_players: value };
    case "duration":
      return { ...result, duration: value };
    default:
      return result;
  }
}

const MODIFICATOR_PRIORITY = ["number_of_players", "duration", "arbitrary"];

class ReservationModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isCompleted: false,
      player_name: "",
      player_phone_number: "",
      player_email: "",
      comment: "",
      agreed_to_privacy_terms: "1", // rails uses 0 or 1 instead of true/false
      agreed_to_receive_news: "1", // rails uses 0 or 1 instead of true/false
      isReserving: false,
      needPayment: false,
      errors: "",
      modificators: null,
      selectedModificator: {},
      selectedOptions: new Set(),
      needPayment: false,
      payment_sum: "0",
      minimalPayment: 0,
      number_of_players: 0,
      duration: 0,
      price: props.price,
      priceWithOptions: calculateFinalPrice(props.price, [], props.discount),
      successfulReserved: false
    };
  }

  componentDidMount() {
    const { itemId, date, time, discount } = this.props;
    fetch(`/reservations/new.json?id=${itemId}&date=${date}&time=${time}`)
      .then(jsonResp => jsonResp.json())
      .then(resp => {
        let selectedModificator = {};
        const foundModificatorKind = MODIFICATOR_PRIORITY.find(modName => {
          return (
            resp.modificators &&
            resp.modificators[modName] &&
            resp.modificators[modName].length > 0
          );
        });
        const foundModificator =
          foundModificatorKind && resp.modificators[foundModificatorKind][0];
        this.setState({
          player_name: resp.name,
          player_phone_number: resp.phone_number,
          player_email: resp.email,
          number_of_players: resp.number_of_players,
          duration: resp.duration,
          modificators: resp.modificators,
          isCompleted: true,
          ...modificatorDiff(
            foundModificator,
            this.state.selectedOptions,
            discount
          )
        });
      });
  }

  setFieldValue = e => {
    const { name, value, type, dataset } = e.target;
    const isNumber = dataset && dataset.number;
    const filteredValue = isNumber ? value.replace(/[^0-9]/g, "") : value;
    this.setState({
      [name]: filteredValue
    });
  };

  toggleCheckbox = e => {
    const { name } = e.target;
    const prevValue = this.state[name];
    this.setState({ [name]: prevValue === "0" ? "1" : "0" });
  };

  setNumberOfPlayers = e => {
    const { modificators, selectedOptions } = this.state;
    const coll = modificators.number_of_players;
    const modificator = coll.find(({ id }) => id.toString() === e.target.value);
    this.setState(
      modificatorDiff(modificator, selectedOptions, this.props.discount)
    );
  };

  setDuration = e => {
    const { modificators, selectedOptions } = this.state;
    const coll = modificators.duration;
    const modificator = coll.find(({ id }) => id.toString() === e.target.value);
    this.setState(
      modificatorDiff(modificator, selectedOptions, this.props.discount)
    );
  };

  setPrice = e => {
    const { modificators, selectedOptions } = this.state;
    const coll = modificators.arbitrary;
    const modificator = coll.find(({ id }) => id.toString() === e.target.value);
    this.setState(
      modificatorDiff(modificator, selectedOptions, this.props.discount)
    );
  };

  toggleOption = option => () => {
    const updatedSelectedOptions = new Set(this.state.selectedOptions);
    updatedSelectedOptions.has(option)
      ? updatedSelectedOptions.delete(option)
      : updatedSelectedOptions.add(option);
    this.setState({
      selectedOptions: updatedSelectedOptions,
      priceWithOptions: calculateFinalPrice(
        this.state.price,
        updatedSelectedOptions,
        this.props.discount
      )
    });
  };

  reserve = () => {
    this.setState({ isReserving: true });
    const token = document.querySelector("[name=csrf-token]").content;
    const { itemId, date, time, rest, referer } = this.props;
    const { comment, selectedModificator, selectedOptions } = this.state;
    const body = {
      id: itemId,
      reservation: {
        date,
        time,
        player_name: this.state.player_name,
        player_phone_number: this.state.player_phone_number,
        player_email: this.state.player_email,
        comment: buildComment(comment, selectedModificator, selectedOptions),
        agreed_to_privacy_terms: this.state.agreed_to_privacy_terms,
        number_of_players: this.state.number_of_players,
        duration: this.state.duration,
        price: this.state.priceWithOptions,
        agreed_to_receive_news: this.state.agreed_to_receive_news,
        rest
      }
    };
    let source = null;
    if (referer && referer.match(/lovushka-quest/)) {
      source = 'lovushka-site'
    } else if (referer && referer.match(/sv-exit/)) {
      source = 'sv-exit-site'
    } else {
      source = Cookies.get("qq_source");
    }
    if (source && source !== '') body.reservation.source_slug = source;
    if (this.state.needPayment) body.payment_sum = this.state.payment_sum;
    fetch("/reservations.json", {
      method: "POST",
      headers: {
        "X-CSRF-TOKEN": token,
        "Content-Type": "application/json;charset=utf-8"
      },
      body: JSON.stringify(body)
    })
      .then(jsonResp => jsonResp.json())
      .then(({ errors, payment, redirect, ok }) => {
        if (errors) {
          this.setState({ errors });
          this.setState({ isReserving: false });
        } else if (payment) {
          this.setState({
            needPayment: true,
            minimalPayment: payment.sum,
            payment_sum: payment.sum.toString(),
            errors: payment.message
          });
          this.setState({ isReserving: false });
        } else if (redirect) {
          window.location.href = redirect;
        } else if (ok) {
          this.setState({ successfulReserved: true });
        }
      });
  };

  render() {
    const {
      close,
      iconPath,
      itemId,
      itemName,
      translation,
      date,
      time,
      rest,
      discount,
      currency
    } = this.props;
    const {
      isCompleted,
      modificators,
      selectedModificator,
      priceWithOptions
    } = this.state;
    return (
      <Modal
        isOpen={isCompleted}
        overlayClassName={"modal"}
        className="modal__container modal__container--m"
        style={{
          overlay: { display: "block" },
          content: { display: "block" }
        }}
      >
        <div className="modal__close" onClick={close}>
          <svg className="modal__close-icon">
            <use xlinkHref={`${iconPath}#icon_close`} />
          </svg>
        </div>
        <div className="modal__content">
          <p className="modal__title--s">{translation.you_are_booking}</p>
          <p className="modal__title--s">«{itemName}»</p>
          {date && time && (
            <p className="modal__subtitle">
              {`${translation.before_date} ${date
                .split("-")
                .reverse()
                .join(".")} ${translation.in} ${time}`}{" "}
              <br />
              <nobr>{`${
                translation.standard_price
              }: ${priceWithOptions} ${currency}`}</nobr>
            </p>
          )}
          <form className="form modal__form">
            {this.state.successfulReserved ? (
              <div>{translation.result}</div>
            ) : this.state.needPayment ? (
              <div>
                <div className="form__block">
                  <input
                    className="form__input"
                    type="text"
                    name="payment_sum"
                    value={this.state.payment_sum}
                    data-number
                    onChange={this.setFieldValue}
                    placeholder={
                      translation.placeholders &&
                      translation.placeholders.payment_sum
                    }
                  />
                </div>
                <div className="form__bottom">
                  <p className="form__tooltip form__tooltip_error">
                    {this.state.errors}
                  </p>
                </div>
                <button
                  className="button button--m button--default button--max form__button"
                  type="button"
                  onClick={this.reserve}
                  disabled={this.state.isReserving}
                >
                  <div className="button__block">
                    <span className="button__text">
                      {this.state.isReserving
                        ? translation.submitting
                        : translation.submit}
                    </span>
                    <svg className="button__icon">
                      <use xlinkHref={`${iconPath}#icon_arr-right`} />
                    </svg>
                  </div>
                </button>
              </div>
            ) : (
              <div>
                {modificators && (
                  <div className="form__block">
                    {modificators.number_of_players &&
                    modificators.number_of_players.length > 0 ? (
                      <select
                        className="form__input"
                        onChange={this.setNumberOfPlayers}
                        value={selectedModificator.id}
                      >
                        {modificators.number_of_players.map(
                          ({ id, value, sum, description }) => (
                            <option value={id} key={id}>
                              {description && description !== ""
                                ? description
                                : `${value} ${translation.person_unit}`}
                              : {calculateFinalPrice(sum, [], discount)}{" "}
                              {currency}
                            </option>
                          )
                        )}
                      </select>
                    ) : modificators.duration &&
                      modificators.duration.length > 0 ? (
                      <select
                        className="form__input"
                        onChange={this.setDuration}
                        value={selectedModificator.id}
                      >
                        {modificators.duration.map(
                          ({ id, value, sum, description }) => (
                            <option value={id} key={id}>
                              {description && description !== ""
                                ? description
                                : `${value} мин`}
                              : {calculateFinalPrice(sum, [], discount)}{" "}
                              {currency}
                            </option>
                          )
                        )}
                      </select>
                    ) : modificators.arbitrary &&
                      modificators.arbitrary.length > 0 ? (
                      <select
                        className="form__input"
                        onChange={this.setPrice}
                        value={selectedModificator.id}
                      >
                        {modificators.arbitrary.map(
                          ({ id, description, sum }) => (
                            <option value={id} key={id}>
                              {description}:{" "}
                              {calculateFinalPrice(sum, [], discount)}{" "}
                              {currency}
                            </option>
                          )
                        )}
                      </select>
                    ) : null}
                  </div>
                )}
                <div className="form__block">
                  <input
                    className="form__input"
                    type="text"
                    name="player_name"
                    value={this.state.player_name}
                    onChange={this.setFieldValue}
                    placeholder={
                      translation.placeholders && translation.placeholders.name
                    }
                  />
                </div>
                <div className="form__block">
                  <input
                    className="form__input"
                    type="text"
                    name="player_phone_number"
                    value={this.state.player_phone_number}
                    onChange={this.setFieldValue}
                    placeholder={
                      translation.placeholders && translation.placeholders.phone
                    }
                  />
                </div>
                <div className="form__block">
                  <input
                    className="form__input"
                    type="email"
                    name="player_email"
                    value={this.state.player_email}
                    onChange={this.setFieldValue}
                    placeholder={
                      translation.placeholders && translation.placeholders.email
                    }
                  />
                </div>
                <div className="form__block">
                  <input
                    className="form__input"
                    type="text"
                    name="comment"
                    value={this.state.comment}
                    onChange={this.setFieldValue}
                    placeholder={
                      translation.placeholders &&
                      translation.placeholders.comment
                    }
                  />
                </div>
                {modificators &&
                  modificators.option &&
                  modificators.option.length > 0 && (
                    <div className="form__block">
                      {modificators.option.map((option, index) => (
                        <label
                          className="form-button checkbox form__label"
                          key={index}
                        >
                          <input
                            className="form-button__input"
                            type="checkbox"
                            checked={this.state.selectedOptions.has(option)}
                            onChange={this.toggleOption(option)}
                          />
                          <svg
                            className="form-button__icon checkbox__icon"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              className="checkbox__icon-box"
                              x="1"
                              y="1"
                              width="18"
                              height="18"
                              rx="5"
                            />
                            <path
                              className="checkbox__icon-check"
                              d="M4,10L8,14L16.5,5.5"
                            />
                          </svg>
                          <span className="form-button__text">
                            {option.description} (+ {option.sum} {currency})
                          </span>
                        </label>
                      ))}
                    </div>
                  )}
                <div className="form__bottom">
                  <p className="form__tooltip form__tooltip_error">
                    {this.state.errors}
                  </p>
                </div>
                <button
                  className="button button--m button--default button--max form__button"
                  type="button"
                  onClick={this.reserve}
                  disabled={this.state.isReserving}
                >
                  <div className="button__block">
                    <span className="button__text">
                      {this.state.isReserving
                        ? translation.submitting
                        : translation.submit}
                    </span>
                    <svg className="button__icon">
                      <use xlinkHref={`${iconPath}#icon_arr-right`} />
                    </svg>
                  </div>
                </button>
                <label className="form-button checkbox form__label">
                  <input
                    className="form-button__input"
                    type="checkbox"
                    name="agreed_to_privacy_terms"
                    onChange={this.toggleCheckbox}
                    checked={this.state.agreed_to_privacy_terms === "1"}
                  />
                  <svg
                    className="form-button__icon checkbox__icon"
                    viewBox="0 0 20 20"
                  >
                    <rect
                      className="checkbox__icon-box"
                      x="1"
                      y="1"
                      width="18"
                      height="18"
                      rx="5"
                    />
                    <path
                      className="checkbox__icon-check"
                      d="M4,10L8,14L16.5,5.5"
                    />
                  </svg>
                  <span className="form-button__text">
                    {translation.i_agree_with}{" "}
                    <a className="form-button__link" href="/rules.pdf" target="_blank">
                      {translation.rules}
                    </a>{" "}
                    {translation.privacy}
                  </span>
                </label>
                <label className="form-button checkbox form__label">
                  <input
                    className="form-button__input"
                    type="checkbox"
                    name="agreed_to_receive_news"
                    onChange={this.toggleCheckbox}
                    checked={this.state.agreed_to_receive_news === "1"}
                  />
                  <svg
                    className="form-button__icon checkbox__icon"
                    viewBox="0 0 20 20"
                  >
                    <rect
                      className="checkbox__icon-box"
                      x="1"
                      y="1"
                      width="18"
                      height="18"
                      rx="5"
                    />
                    <path
                      className="checkbox__icon-check"
                      d="M4,10L8,14L16.5,5.5"
                    />
                  </svg>
                  <span className="form-button__text">
                    {translation.news_and_ads}
                  </span>
                </label>
              </div>
            )}
          </form>
        </div>
      </Modal>
    );
  }
}

Modal.setAppElement(document.querySelector("body"));

export default ReservationModal;
